<template>
    <div>
        <br>
        <table>
            <tbody>
            <tr>
                <td class="blue bold">ПРЕДВАРИТЕЛЬНОЕ ОБСЛЕДОВАНИЕ</td>
                <td class="blue x1 bold">5 000 руб.</td>
            </tr>
            <tr>
                <td colspan="2" class="bold">Консультации специалистов:</td>
            </tr>
            <tr>
                <td colspan="2">Прием терапевта;</td>
            </tr>
            <tr>
                <td colspan="2">Первичный и повторный прием акушера – гинеколога;</td>
            </tr>
            <tr>
                <td colspan="2">Диагностические исследования:</td>
            </tr>
            <tr>
                <td colspan="2">Клинический анализ крови</td>
            </tr>
            <tr>
                <td colspan="2">Анализ мочи общий</td>
            </tr>
            <tr>
                <td colspan="2">Биохимический анализ крови (глюкоза, общий билирубин, АЛТ, АСТ, креатинин);</td>
            </tr>
            <tr>
                <td colspan="2">ЭКГ</td>
            </tr>
            <tr>
                <td colspan="2">УЗИ</td>
            </tr>
            </tbody>
        </table>
        <br>
        <table>
            <tbody>
            <tr>
                <td class="blue bold" rowspan="2">ВЕДЕНИЕ БЕРЕМЕННОСТИ СТАНДАРТ</td>
                <td class="blue x1 bold">I триместр</td>
                <td class="blue x1 bold">II триместр</td>
                <td class="blue x1 bold">III триместр</td>
            </tr>
            <tr>
                <td class="blue x1">(1-14 недель)</td>
                <td class="blue x1">(14-28 недель)</td>
                <td class="blue x1">(28-41 недель)</td>
            </tr>
            <tr>
                <td class="blue bold">Стоимость программы 95 000 руб.</td>
                <td class="blue x1 bold">33 500 руб.</td>
                <td class="blue x1 bold">24 900 руб.</td>
                <td class="blue x1 bold">36 600 руб.</td>
            </tr>
            <tr>
                <td class="bold">Консультации специалистов:</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием акушера-гинеколога</td>
                <td class="x1">3</td>
                <td class="x1">3</td>
                <td class="x1">6</td>
            </tr>
            <tr>
                <td>Консультация заведующего отделением гинекологии</td>
                <td class="x1"></td>
                <td class="x1">1</td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием отоларинголога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием офтальмолога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием стоматолога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="bold">Лабораторные исследования:</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td>(Согласно приказу МЗ РФ №572н от 01.11.2012г.)</td>
            </tr>
            <tr>
                <td rowspan="2">Клинический анализ крови</td>
                <td rowspan="2" class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td>Общий анализ мочи</td>
                <td class="x1">2</td>
                <td class="x1">3</td>
                <td class="x1">6</td>
            </tr>
            <tr>
                <td rowspan="2">Биохимический анализ крови (мочевина, общий белок, общий билирубин, прямой билирубин,
                    АЛТ, АСТ, креатинин, железо, ЛПВП, ЛПНП, триглицериды, холестерин)
                </td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td rowspan="3">Коагулограмма (время свертываемости, время кровотечения, АЧТВ, фибриноген,
                    протромбиновое время,
                    тромбиновое время, Д-димер, определение волчаночного антикоагулянта (ВА))
                </td>
                <td class="x1" rowspan="3">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td class="x1">кроме ВА</td>
                <td class="x1">кроме ВА</td>
            </tr>
            <tr>
                <td>Группа крови, Rh-фактор</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td>(При Rh(-) женщине у матери – обследование отца на группу крови и Rh-фактор. При Rh(+) у отца,
                    обследование Rh(-) женщины (1 раз)).
                </td>
            </tr>
            <tr>
                <td>Исследование гормонов щитовидной железы (Т4 свободный, ТТГ, антитела к тиреопероксидазе).</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Анализ на сифилис (RW)</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Анализ на ВИЧ</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Анализ на гепатиты В и С</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Антитела IgG, IgM к токсоплазме</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Антитела IgG, IgM к вирусу краснухе</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td rowspan="2">Исследование на флору</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(16-18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td>Исследование на цитологию</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td rowspan="2">Пренатальный скрининг для выявления пороков развития плода DELFIA-LifeCycle I триместра
                    беременности (РАРР-А + свободный в-ХГЧ)
                </td>
                <td class="x1">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td class="x1">(11-14 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Пренатальный скрининг для выявления пороков развития плода DELFIA-LifeCycle II триместра
                    беременности (АФП + свободный в-ХГЧ + свободный эстриол), кровь (сыворотка)
                </td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td class="x1">(16-18 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Бактериологическое исследование влагалищного отделяемого</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(35 неделя)</td>
            </tr>
            <tr>
                <td>Бактериоскопическое исследование на половые инфекции методом ПЦР (гонорея, хламидии, трихомонада)
                </td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td rowspan="2">УЗИ</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(11-14 неделя)</td>
                <td class="x1">(18-21 неделя)</td>
                <td class="x1">(30-34 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Допплерометрия</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(30-34 неделя)</td>
            </tr>
            <tr>
                <td>Кардиотокография (КТГ)</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Электрокардиография (ЭКГ)</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Кольпоскопия</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Пальпация плода, аускультация плода, окружность живота ВДМ, тонус матки</td>
                <td class="x1"></td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Однократный прием врача - акушер - гинеколога в течение 2 месяцев после родов</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            </tbody>
        </table>
        <br>
        <table>
            <tbody>
            <tr>
                <td class="blue bold" rowspan="2">ВЕДЕНИЕ БЕРЕМЕННОСТИ VIP</td>
                <td class="blue x1 bold">I триместр</td>
                <td class="blue x1 bold">II триместр</td>
                <td class="blue x1 bold">III триместр</td>
            </tr>
            <tr>
                <td class="blue x1">(1-14 недель)</td>
                <td class="blue x1">(14-28 недель)</td>
                <td class="blue x1">(28-41 недель)</td>
            </tr>
            <tr>
                <td class="blue bold">Стоимость программы 120 000 руб.</td>
                <td class="blue x1 bold">40 300 руб.</td>
                <td class="blue x1 bold">27 100 руб.</td>
                <td class="blue x1 bold">52 600 руб.</td>
            </tr>
            <tr>
                <td class="bold">Консультации специалистов:</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием акушера-гинеколога</td>
                <td class="x1">неограниченно</td>
                <td class="x1">неограниченно</td>
                <td class="x1">неограниченно</td>
            </tr>
            <tr>
                <td>Консультация заведующего отделением гинекологии</td>
                <td class="x1"></td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Прием психотерапевта</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2">1</td>
            </tr>
            <tr>
                <td>(психологическая подготовка к родам)</td>
            </tr>
            <tr>
                <td>Прием врача по ЛФК и спорту</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Прием отоларинголога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием офтальмолога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Прием стоматолога</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="bold">Лабораторные исследования:</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td>(Согласно приказу МЗ РФ №572н от 01.11.2012г.)</td>
            </tr>
            <tr>
                <td rowspan="2">Клинический анализ крови</td>
                <td rowspan="2" class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td>Общий анализ мочи</td>
                <td class="x1">2</td>
                <td class="x1">3</td>
                <td class="x1">6</td>
            </tr>
            <tr>
                <td rowspan="2">Биохимический анализ крови (мочевина, общий белок, общий билирубин, прямой билирубин,
                    АЛТ, АСТ, креатинин, железо, ЛПВП, ЛПНП, триглицериды, холестерин)
                </td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td rowspan="3">Коагулограмма (время свертываемости, время кровотечения, АЧТВ, фибриноген,
                    протромбиновое время,
                    тромбиновое время, Д-димер, определение волчаночного антикоагулянта (ВА))
                </td>
                <td class="x1" rowspan="3">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td class="x1">кроме ВА</td>
                <td class="x1">кроме ВА</td>
            </tr>
            <tr>
                <td>Группа крови, Rh-фактор</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td>(При Rh(-) женщине у матери – обследование отца на группу крови и Rh-фактор. При Rh(+) у отца,
                    обследование Rh(-) женщины (1 раз)).
                </td>
            </tr>
            <tr>
                <td>Исследование гормонов щитовидной железы (Т4 свободный, ТТГ, антитела к тиреопероксидазе).</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Анализ на сифилис (RW)</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Анализ на ВИЧ</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Анализ на гепатиты В и С</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Антитела IgG, IgM к токсоплазме</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Антитела IgG, IgM к вирусу краснухе</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td rowspan="2">Исследование на флору</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(16-18 неделя)</td>
                <td class="x1">(30 неделя)</td>
            </tr>
            <tr>
                <td>Исследование на цитологию</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td rowspan="2">Пренатальный скрининг для выявления пороков развития плода DELFIA-LifeCycle I триместра
                    беременности (РАРР-А + свободный в-ХГЧ)
                </td>
                <td class="x1">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td class="x1">(11-14 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Пренатальный скрининг для выявления пороков развития плода DELFIA-LifeCycle II триместра
                    беременности (АФП + свободный в-ХГЧ + свободный эстриол), кровь (сыворотка)
                </td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
                <td class="x1" rowspan="2"></td>
            </tr>
            <tr>
                <td class="x1">(16-18 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Бактериологическое исследование влагалищного отделяемого</td>
                <td class="x1" rowspan="2">1</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(35 неделя)</td>
            </tr>
            <tr>
                <td>Бактериоскопическое исследование на половые инфекции методом ПЦР (гонорея, хламидии, трихомонада)
                </td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td rowspan="2">УЗИ</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(11-14 неделя)</td>
                <td class="x1">(18-21 неделя)</td>
                <td class="x1">(30-34 неделя)</td>
            </tr>
            <tr>
                <td rowspan="2">Допплерометрия</td>
                <td class="x1" rowspan="2"></td>
                <td class="x1" rowspan="2"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td class="x1">(30-34 неделя)</td>
            </tr>
            <tr>
                <td>Кардиотокография (КТГ)</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Электрокардиография (ЭКГ)</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Индивидуальные занятия ЛФК</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1">10</td>
            </tr>
            <tr>
                <td>Кольпоскопия</td>
                <td class="x1">1</td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            <tr>
                <td>Пальпация плода, аускультация плода, окружность живота ВДМ, тонус матки</td>
                <td class="x1"></td>
                <td class="x1">1</td>
                <td class="x1">1</td>
            </tr>
            <tr>
                <td>Однократный прием врача - акушер - гинеколога в течение 2 месяцев после родов</td>
                <td class="x1"></td>
                <td class="x1"></td>
                <td class="x1"></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "DepartmentStaticTable",
}

</script>

<style lang="scss" scoped>
table {
    width: 100%;
    color: #666;
    background-color: white;
    font-size: 12px;
}

table, th, td {
    border: 1px solid #ddd;
    border-collapse: collapse;
}

.blue {
    background-color: rgb(0, 102, 136);
    color: white;
}

td {
    text-align: left;
    padding: 3px;
}

td {
}

td.x1 {
    width: 146px;
    text-align: center;
}

td.x2 {
    width: 292px;
    text-align: center;
}

.bold {
    font-weight: bold;
}
</style>
